import {
    GET_CAREER_PATH_REQUEST, GET_CAREER_PATH_SUCCESS, GET_CAREER_PATH_FAIL,
    GET_ALL_CAREER_PATHS_REQUEST, GET_ALL_CAREER_PATHS_SUCCESS, GET_ALL_CAREER_PATHS_FAIL,
    GET_ACTIVE_CAREER_PATHS_REQUEST, GET_ACTIVE_CAREER_PATHS_SUCCESS, GET_ACTIVE_CAREER_PATHS_FAIL,
    CREATE_CAREER_PATH_REQUEST, CREATE_CAREER_PATH_SUCCESS, CREATE_CAREER_PATH_FAIL,
    UPDATE_CAREER_PATH_REQUEST, UPDATE_CAREER_PATH_SUCCESS, UPDATE_CAREER_PATH_FAIL,
    DELETE_CAREER_PATH_REQUEST, DELETE_CAREER_PATH_SUCCESS, DELETE_CAREER_PATH_FAIL,
    SET_CAREER_PATH_LOADING
} from '../actions/careerPathActions';

const initialState = {
    careerPaths: [],
    currentCareerPath: null,
    loading: false,
    error: null,
    message: ''
};

function careerPathReducer(state = initialState, action) {
    switch (action.type) {

        case SET_CAREER_PATH_LOADING:
            return { ...state, loading: action.payload };

        case GET_CAREER_PATH_REQUEST:
        case GET_ALL_CAREER_PATHS_REQUEST:
        case GET_ACTIVE_CAREER_PATHS_REQUEST:
        case CREATE_CAREER_PATH_REQUEST:
        case UPDATE_CAREER_PATH_REQUEST:
        case DELETE_CAREER_PATH_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_CAREER_PATH_SUCCESS:
            return { ...state, loading: false, currentCareerPath: action.payload };

        case GET_ALL_CAREER_PATHS_SUCCESS:
        case GET_ACTIVE_CAREER_PATHS_SUCCESS:
            return { ...state, loading: false, careerPaths: action.payload };

        case CREATE_CAREER_PATH_SUCCESS:
            return { ...state, loading: false, careerPaths: [...state.careerPaths, action.payload] };

        case UPDATE_CAREER_PATH_SUCCESS:
            return {
                ...state,
                loading: false,
                careerPaths: state.careerPaths.map(cp =>
                    cp.id === action.payload.id ? action.payload : cp
                ),
                currentCareerPath: state.currentCareerPath?.id === action.payload.id
                    ? action.payload : state.currentCareerPath
            };

        case DELETE_CAREER_PATH_SUCCESS:
            return {
                ...state,
                loading: false,
                careerPaths: state.careerPaths.filter(cp => cp.id !== action.payload.careerPathId),
                currentCareerPath: state.currentCareerPath?.id === action.payload.careerPathId
                    ? null : state.currentCareerPath
            };

        case GET_CAREER_PATH_FAIL:
        case GET_ALL_CAREER_PATHS_FAIL:
        case GET_ACTIVE_CAREER_PATHS_FAIL:
        case CREATE_CAREER_PATH_FAIL:
        case UPDATE_CAREER_PATH_FAIL:
        case DELETE_CAREER_PATH_FAIL:
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
}

export default careerPathReducer;